<template>
  <!-- Halloween animation -->
  <!-- <div class="snowflakes" aria-hidden="true"> -->
    <!-- <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/pumpkin_25ec5c38cc.png?updated_at=2023-10-15T03:16:19.383Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/witch_213cb176ca.png?updated_at=2023-10-15T03:16:19.281Zg" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/costume_4c6c6c468f.png?updated_at=2023-10-15T03:16:18.853Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/ghost_9aa977db0d.png?updated_at=2023-10-15T03:16:18.773Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/pumpkin_25ec5c38cc.png?updated_at=2023-10-15T03:16:19.383Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/witch_213cb176ca.png?updated_at=2023-10-15T03:16:19.281Zg" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/costume_4c6c6c468f.png?updated_at=2023-10-15T03:16:18.853Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/ghost_9aa977db0d.png?updated_at=2023-10-15T03:16:18.773Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/pumpkin_25ec5c38cc.png?updated_at=2023-10-15T03:16:19.383Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/witch_213cb176ca.png?updated_at=2023-10-15T03:16:19.281Zg" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/costume_4c6c6c468f.png?updated_at=2023-10-15T03:16:18.853Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/ghost_9aa977db0d.png?updated_at=2023-10-15T03:16:18.773Z" alt="" style="width: 30px;height: 30px;" >                
    </div> -->

  <!-- Avurudu animation -->
    <!-- <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_2_98db03bcb4.png?updated_at=2023-04-06T12:54:19.468Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_4_037d13897d.png?updated_at=2023-04-06T12:54:21.313Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_1_58e59b27c9.png?updated_at=2023-04-06T12:30:50.933Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_6_69eaaa4ae3.png?updated_at=2023-04-06T12:54:19.936Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_10_a2f4b07073.png?updated_at=2023-04-06T12:54:18.617Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_9_86f08bc2d9.png?updated_at=2023-04-06T12:54:18.588Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_2_98db03bcb4.png?updated_at=2023-04-06T12:54:19.468Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_4_037d13897d.png?updated_at=2023-04-06T12:54:21.313Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_1_58e59b27c9.png?updated_at=2023-04-06T12:30:50.933Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_6_69eaaa4ae3.png?updated_at=2023-04-06T12:54:19.936Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_10_a2f4b07073.png?updated_at=2023-04-06T12:54:18.617Z" alt="" style="width: 30px;height: 30px;" >                
    </div>
    <div class="snowflake">
      <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_9_86f08bc2d9.png?updated_at=2023-04-06T12:54:18.588Z" alt="" style="width: 30px;height: 30px;" >                
    </div> -->
    
  <!-- snowflakes -->
    <!-- <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❆</div>
    <div class="snowflake">❅</div>
    <div class="snowflake">❅</div> -->
  <!-- </div> -->

  <div class="hearts" style="display:none;">
    <div class="heartOne">
      <div class="left-side"></div>
      <div class="right-side"></div>
    </div>
    <div class="heartTwo">
      <div class="left-side"></div>
      <div class="right-side"></div>
    </div>
    <div class="heartThree">
      <div class="left-side"></div>
      <div class="right-side"></div>
    </div>
    <div class="heartFour">
      <div class="left-side"></div>
      <div class="right-side"></div>
    </div>
    <div class="heartFive">
      <div class="left-side"></div>
      <div class="right-side"></div>
    </div>
  </div>

  <div style="text-align: left">
    <div class="mt-3">
        <div style="width:100%;">
          <div class="skeleton" v-if="showSkelton" style="height: 170px;">
            <div class="s-img"></div>
          </div>
        </div>

        <!-- CountDown Module Started  -->
        <!-- test -->
        <!-- Before CountDown Section Started -->
        <div class="row mt-3" style="display:none;">
          <div class="container">
            <div class="promotion_countdown_center">
              <a href="#">
                <div class="row">
                  <div class="col-4">
                    <div style="margin-left:5%;margin-top: 55%;"></div>
                  </div>
                  <div class="col-8">
                    <div class="countdown" style="margin-top: 6%;">
                      <div class="countdown-item">
                        <span id="day">-</span>
                        <span style="font-size:10px;">Day</span>
                      </div>

                      <div class="countdown-item">
                        <span id="hour">-</span>
                        <span style="font-size:10px;">Hours</span>
                      </div>

                      <div class="countdown-item">
                        <span id="minute">-</span>
                        <span style="font-size:10px;">Minutes</span>
                      </div>

                      <div class="countdown-item">
                        <span id="second">-</span>
                        <span style="font-size:10px;">Seconds</span>
                      </div>

                      <div class="pulse"></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- no delas banner  -->
        <!-- <div class="row mt-3" style="display:none;">
          <div class="NoDeals">Deals are Coming Soon ...</div>
        </div>
        <img
          v-if="!banners || !banners.length"
          src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/istockphoto_1357365823_612x612_45a0e4bbf8.jpg?updated_at=2022-08-05T06:22:33.899Z"
          alt=""
          style="height:100%;width: 100%;border-radius: 16px; rgb(221 11 126 / 34%) 0px 4px 8px 0px;transition: 0.3s;"
        /> -->
        <div class="container">
        <div class="row mt-3" v-if="showBanners">
          <Splide :options="Leaderboard_BannerOptions">
            <SplideSlide v-for="item in this.banners" :key="item.id">
              <a href="#">
                <img
                  :src="item.formats.small.url"
                  alt="Sample 1"
                  style="height:100%;width: 100%;border-radius: 16px; rgb(221 11 126 / 34%) 0px 4px 8px 0px;transition: 0.3s;"
                />
              </a>
            </SplideSlide>
          </Splide>
        </div>

        <!-- Deals Strip Banner  -->
        <div class="row mt-3" v-if="stripBanner">
          <Splide :options="stripBanner_options">
            <SplideSlide v-for="items in stripBannerList" :key="items.id">
              <a :href="items.BannerLink">
                <img
                  :src="items.bannerUpload.formats.small.url"
                  alt="Sample 1"
                  style="height:95%;width: 100%;border-radius: 16px; rgb(221 11 126 / 34%) 0px 4px 8px 0px;transition: 0.3s;"
                />
              </a>
            </SplideSlide>
          </Splide>
        </div>    
        <!-- Deals Strip Banner Ends -->

        <!-- Category Section Start -->
    <div class="categories">
      <div class="scrollmenu">
        <ul class="cat-list">
          <li
            class="nav-item cat-item"
            role="presentation"
            v-for="items in homePageCategoriesFilteredData"
            :key="items.id"
            :style="{
              // backgroundColor: this.categoryBgColor,
              backgroundColor: items.selected ? this.categoryBgColor : inactiveCategoryBgColor,
       
            }"
            @click="getMerchantsByCategorySlug(items.Slug, items.id)"
          >
            
              <div
                style="font-size: 10pt"
                :style="{
                  color: items.selected ? this.categoryFontColor : inactiveFontColor,
                }"
              >
                {{ items.Category_Name }}
              </div>
            
          </li>
        </ul>
      </div>
    </div>
    <!-- Category Section End -->


        <!-- <div class="scrollmenu" style="margin-bottom: -3%;">
          <ul
            class="nav nav-pills mb-2"
            id="pills-tab"
            role="tablist"
            style=" overflow-x: scroll; overflow-y: hidden;white-space: nowrap;display: inherit;height: 50px;background-color: transparent;border-radius: 0%;box-shadow: none;padding-right:2%;padding-left:2%;"

          > -->
            <!-- <li

         
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link active"
                id="pills-topdeals-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-topdeals"
                type="button"
                role="tab"
                aria-controls="pills-topdeals"
                aria-selected="true"
                @click="getTopdealsMerchantByCategory()"
              >
                Top Deals
              </button>
            </li>
            <li
              class="nav-item active"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link active"
                id="pills-fashion-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-fashion"
                type="button"
                role="tab"
                aria-controls="pills-fashion"
                aria-selected="false"
                @click="getFashionMerchantByCategory()"
              >
                Fashion
              </button>
            </li> -->
            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-electronics-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-electronics"
                type="button"
                role="tab"
                aria-controls="pills-electronics"
                aria-selected="false"
                @click="getElectronicMerchantByCategory()"
              >
                Electronics
              </button>
            </li> -->

           <!--  
            <li


              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link active"
                id="pills-restaurant-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-restaurant"
                type="button"
                role="tab"
                aria-controls="pills-restaurant"
                aria-selected="false"
                @click="getRestaurantMerchantByCategory()"
              >
              Services
              </button>
            </li> -->

            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-beauty-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-beauty"
                type="button"
                role="tab"
                aria-controls="pills-beauty"
                aria-selected="false"
                @click="getBeautyCosmeticsMerchantByCategory()"
              >
              Health & Beauty
              </button>
            </li> -->


            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-lifestyle-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-lifestyle"
                type="button"
                role="tab"
                aria-controls="pills-lifestyle"
                aria-selected="false"
                @click="getLIfeStyleMerchantByCategory()"
              >
              Home & Lifestyle
              </button>
            </li> -->

          

            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-travel-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-travel"
                type="button"
                role="tab"
                aria-controls="pills-travel"
                aria-selected="false"
                @click="getTravelMerchantByCategory()"
              >
              Travels & Services
              </button>
            </li> -->

            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-fitness-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-fitness"
                type="button"
                role="tab"
                aria-controls="pills-fitness"
                aria-selected="false"
                style="color:#2b2b2b;"
                @click="getFitnessMerchantByCategory()"
              >
                Fitness
              </button>
            </li> -->

            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link active"
                id="pills-other-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-other"
                type="button"
                role="tab"
                aria-controls="pills-other"
                aria-selected="false"
                @click="getOtherMerchantByCategory()"
                disabled
              >
                Other Deals
              </button>
            </li> -->

            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link active"
                id="pills-other-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-other"
                type="button"
                role="tab"
                aria-controls="pills-other"
                aria-selected="false"
                style="color:#2b2b2b;"
              >
                Books Deals
              </button>
            </li> -->

            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-footwear-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-footwear"
                type="button"
                role="tab"
                aria-controls="pills-footwear"
                aria-selected="false"
                @click="getFootwearMerchantByCategory()"
              >
              Footwear
              </button>
            </li> -->
            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-mart-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-mart"
                type="button"
                role="tab"
                aria-controls="pills-mart"
                aria-selected="true"
                @click="getMartdealsMerchant()"
              >
                Mart
              </button>
            </li> -->
            <!-- <li
              class="nav-item"
              role="presentation"
              style="display: inline-block;"
            >
              <button
                class="nav-link"
                id="pills-mart-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-mart"
                type="button"
                role="tab"
                aria-controls="pills-mart"
                aria-selected="true"
                @click="getShopLocal()"
              >
                See More
              </button>
            </li> -->
          <!-- </ul> -->
          <!-- <div class="row">
            <div class="col-9">
              <div class="sectionHead2">
                Spooky Deals
              </div>
            </div>
          </div> -->
        <!-- </div> -->

        <div class="row" style="margin-bottom: 5%;" v-if="showFashionDeals">
              <div
                class="col-6 text-center"

                v-for="items in this.merchantList"
                :key="items.id"
              >
              <!-- {{ items }} -->
              <div class="circle" v-if="merchantsLoading">


              <img
                src="@/assets/images/Loading-Icon-unscreen.gif"
                alt=""
                style="width: 100%;border-radius: 15px;"
              />
            </div>

              <div class="text-center mt-0" v-if="showMerchants">


                <a :href="'/m/merchant/' + items.id">
                <div class="product-card">
                    <div class="badge">{{ items.merchantDiscount }}</div>
                    <div class="badge2" v-if="items.merchantDiscountSecondTag" >
                      {{ items.merchantDiscountSecondTag }}
                    </div>
                    <div class="badge3" v-if="items.merchant_types.length > 0">
                      <span>
                        <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                      </span>
                      <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in items.merchant_types" :key="type.id"> 
                        {{ type.Type }}
                        <span v-if="type != items.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                      </span>
                    </div>

                    <div class="product-tumb">
                    <img :src="items.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                    </div>
                  </div>
                </a>
              </div>
                <!-- <MercSpecDealBannerMob :id="items.id" /> -->
              </div>
            </div>
      
        <div class="tab-content" id="pills-tabContent" style="margin-bottom:5%;">
          <div
            class="tab-pane fade"
            id="pills-fashion"
            role="tabpanel"
            aria-labelledby="pills-fashion-tab"
          >
           
          </div>
          <div
            class="tab-pane fade"
            id="pills-electronics"
            role="tabpanel"
            aria-labelledby="pills-electronics-tab"
          >
            <!-- Electronics -->
            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="items in this.merchantList"
                :key="items.id"
              >
              <div class="circle" v-if="Electronicsloading">
              <img
                src="@/assets/images/Loading-Icon-unscreen.gif"
                alt=""
                style="width: 100%;border-radius: 15px;"
              />
            </div>
              <div class="text-center mt-0" v-if="showElectronics">
                <a :href="'/m/merchant/' + items.id">
                <div class="product-card">
                    <div class="badge">{{ items.merchantDiscount }}</div>
                    <div class="badge2" v-if="items.merchantDiscountSecondTag" >
                      {{ items.merchantDiscountSecondTag }}
                    </div>
                    <div class="badge3" v-if="items.merchant_types.length > 0">
                      <span>
                        <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                      </span>
                      <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in items.merchant_types" :key="type.id"> 
                        {{ type.Type }}
                        <span v-if="type != items.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                      </span>
                    </div>

                    <div class="product-tumb">
                    <img :src="items.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                    </div>
                  </div>
                </a>
              </div>
                <!-- <MercSpecDealBannerMob :id="items.id" /> -->
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-fashion"
            role="tabpanel"
            aria-labelledby="pills-fashion-tab"
          >
            <!-- Fashion Deals  -->

            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="item in this.merchantList"
                :key="item.id"
              >
              <!-- {{ item }} -->
                <!-- <MercSpecDealBannerMob :id="item.id" /> -->
                <div class="circle" v-if="Fashionloading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showFashion">
                    <a :href="'/m/merchant/' + item.id">
                      <div class="product-card">
                      <div class="badge">{{ item.merchantDiscount }}</div>
                      <div class="badge2" v-if="item.merchantDiscountSecondTag" >
                        {{ item.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="item.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in item.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != item.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="item.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-lifestyle"
            role="tabpanel"
            aria-labelledby="pills-lifestyle-tab"
          >
            <!-- Life Style  Deals-->
            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="items in this.merchantList"
                :key="items.id"
              >
              <div class="circle" v-if="Lifestyleloading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showLifestyle">
                    <a :href="'/m/merchant/' + items.id">
                      <div class="product-card">
                      <div class="badge">{{ items.merchantDiscount }}</div>
                      <div class="badge2" v-if="items.merchantDiscountSecondTag" >
                        {{ items.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="items.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in items.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != items.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="items.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="items.id" /> -->
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-beauty"
            role="tabpanel"
            aria-labelledby="pills-beauty-tab"
          >
            <!-- Beauty and Cosmetics deals -->

            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="item in this.merchantList"
                :key="item.id"
              >
              <div class="circle" v-if="Beautyloading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showBeauty">
                    <a :href="'/m/merchant/' + item.id">
                      <div class="product-card">
                      <div class="badge">{{ item.merchantDiscount }}</div>
                      <div class="badge2" v-if="item.merchantDiscountSecondTag" >
                        {{ item.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="item.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in item.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != item.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="item.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="item.id" /> -->
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-fitness"
            role="tabpanel"
            aria-labelledby="pills-fitness-tab"
          >
            <!-- Fitness Deals -->
            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="item in this.merchantList"
                :key="item.id"
              >
              <div class="circle" v-if="Fitnessloading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showFitness">
                    <a :href="'/m/merchant/' + item.id">
                      <div class="product-card">
                      <div class="badge">{{ item.merchantDiscount }}</div>
                      <div class="badge2" v-if="item.merchantDiscountSecondTag" >
                        {{ item.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="item.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in item.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != item.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="item.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="item.id" /> -->
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade show active"
            id="pills-other"
            role="tabpanel"
            aria-labelledby="pills-other-tab"
          >
            <!-- Other Deals -->

            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="item in this.other"
                :key="item.id"
              >
              <div class="circle" v-if="Otherloading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showOther">
                    <a :href="'/m/merchant/' + item.id">
                      <div class="product-card">
                      <div class="badge">{{ item.merchantDiscount }}</div>
                      <div class="badge2" v-if="item.merchantDiscountSecondTag" >
                        {{ item.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="item.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in item.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != item.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="item.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="item.id" /> -->
              </div>
            </div>
            <!-- <div id="home"></div> -->
          </div>

          <div
            class="tab-pane fade"
            id="pills-travel"
            role="tabpanel"
            aria-labelledby="pills-travel-tab"
          >
            <!-- Travel -->
            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="items in this.travel"
                :key="items.id"
              >
                <div class="circle" v-if="travelAndServicesLoading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showTravelAndServices">
                    <a :href="'/m/merchant/' + items.id">
                      <div class="product-card">
                      <div class="badge">{{ items.merchantDiscount }}</div>
                      <div class="badge2" v-if="items.merchantDiscountSecondTag" >
                        {{ items.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="items.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in items.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != items.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="items.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="items.id" /> -->
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-footwear"
            role="tabpanel"
            aria-labelledby="pills-footwear-tab"
          >
            <!-- Footwear Deals  -->

            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="item in this.merchantList"
                :key="item.id"
              >
                <!-- <MercSpecDealBannerMob :id="item.id" /> -->
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="pills-restaurant"
            role="tabpanel"
            aria-labelledby="pills-restaurant-tab"
          >
            <!-- Service  Deals-->
            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="items in this.merchantList"
                :key="items.id"
              >
              <div class="circle" v-if="merchantsLoading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showMerchants">
                    <a :href="'/m/merchant/' + items.id">
                      <div class="product-card">
                      <div class="badge">{{ items.merchantDiscount }}</div>
                      <div class="badge2" v-if="items.merchantDiscountSecondTag" >
                        {{ items.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="items.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in items.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != items.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="items.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="items.id" /> -->
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-mart"
            role="tabpanel"
            aria-labelledby="pills-mart-tab"
          >
            <!-- Mart  Deals-->
            <div class="row" style="margin-bottom: 5%;">
              <div
                class="col-6 text-center"
                v-for="items in this.mart"
                :key="items.id"
              >
              <div class="circle" v-if="Martloading">
                  <img
                    src="@/assets/images/Loading-Icon-unscreen.gif"
                    alt=""
                    style="width: 100%;border-radius: 15px;"
                  />
                </div>
                <div class="text-center mt-0" v-if="showMart">
                    <a :href="'/m/merchant/' + items.id">
                      <div class="product-card">
                      <div class="badge">{{ items.merchantDiscount }}</div>
                      <div class="badge2" v-if="items.merchantDiscountSecondTag" >
                        {{ items.merchantDiscountSecondTag }}
                      </div>
                      <div class="badge3" v-if="items.merchant_types.length > 0">
                        <span>
                          <img src="@/assets/images/shopping-bag.png" alt=“merchant-type-logo” height="10" style="margin-right: 2px; margin-top: -2px;">
                        </span>
                        <span class="bg animated fadeInDown" style="color:#000000;" v-for="type in items.merchant_types" :key="type.id"> 
                          {{ type.Type }}
                          <span v-if="type != items.merchant_types.slice(-1)[0]" style="padding-left: 2px;">|</span>
                        </span>
                      </div>

                      <div class="product-tumb">
                      <img :src="items.rectBannerUrl.formats.thumbnail.url" alt="" style="width: 100%; border-radius: 20px;">
                      </div>
                    </div>
                  </a>
               </div>
                <!-- <MercSpecDealBannerMob :id="items.id" /> -->
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Interop vue 2 component to vue 3
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";
// import MerRectDisp from "@/components/MerRectDisp";
// import MercSpecDealBannerMob from "@/components/MercSpecDealBannerMob";
toVue3.register(Vue2, Vue3);
import "@splidejs/splide/dist/css/splide.min.css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";

import Strapi from "../services/strapi-services.js";
const strapi = new Strapi();

export default {
  name: "MobDealsTestEnv",
  components: {
    // MercSpecDealBannerMob,
  },
  setup() {
    const Leaderboard_BannerOptions = {
      type: "fade",
      rewind: true,
      autoplay: true,
      arrows: false,
      pagination: false,
    };
    const stripBanner_options = {
      type: "fade",
      rewind: true,
      autoplay: true,
      arrows: false,
      pagination: true,
      height: "100%",
    };
    return {
      Leaderboard_BannerOptions,
      stripBanner_options
    }
  },
  data() {
    return {
      showFashionDeals:true,
      Splide,
      SplideSlide,
      showPromotion: false,
      scTimer: 0,
      scY: 0,
      drawerVisible: false,
      showTopMercs: true,
      finalId: 0,
      cattype: "deals",
      transition: "fade",
      topdeals: [],
      electronics: [],
      fashion: [],
      lifestyle: [],
      beauty: [],
      fitness: [],
      footwear: [],
      other: [],
      banners: [],
      defaultLink:
        "https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/sample/StayTuned.jpg",
      defaultBanner: null,
      // "https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/sample/StayTuned.jpg",
      showSkelton: true,
      showBanners: false,
      travel: [],
      restaurants: [],
      stripBannerList: [],
      stripBanner: false,
      mart: [],
      Fashionloading: true,
      showFashion:false,
      showElectronics:false,
      Electronicsloading:true,
      showBeauty:false,
      Beautyloading:true,
      showLifestyle:false,
      Lifestyleloading:true,
      showMart:false,
      Martloading:true,
      merchantsLoading:true,
      showMerchants:false,
      travelAndServicesLoading: true,
      showTravelAndServices: false,

      dealsPageCategories:[],

      categoryFontColor: "",
      categoryBgColor: "",
      merchantList:[],

      Fitnessloading:true,
      showFitness:false,
      Otherloading:true,
      showOther:false,

      inactiveCategoryBgColor: '#D9D9D9CC',
      inactiveFontColor: '#000000',
      

    };
  },
  created() {
    // document.title = "Deals @ Koko";
    document.title = "Buy Now Pay Later with Koko";
    this.GetAllsiteSettings();
    // Fetching Data From categories

    // this.getTopdealsMerchantByCategory();
    // this.getElectronicMerchantByCategory();
    // this.getFashionMerchantByCategory();
    // this.getLIfeStyleMerchantByCategory();
    // this.getBeautyCosmeticsMerchantByCategory();
    // this.getFitnessMerchantByCategory();
    // this.getOtherMerchantByCategory();
    // this.getTheCampaignHeroBanners();
    // this.getTopdealsMerchantByCategory();
    // this.getRestaurantMerchantByCategory(); 
    // this.getTravelMerchantByCategory();
    this.getStripBanners();
    this.getDealsPageCategories();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    var countDownDate = new Date("May 03, 2022 00:00:00").getTime();
    var x = setInterval(function() {
      var now = new Date().getTime();

      var distance = countDownDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      document.getElementById("day").innerText = days;
      document.getElementById("hour").innerText = hours;
      document.getElementById("minute").innerText = minutes;
      document.getElementById("second").innerText = seconds;

      if (distance < 0) {
        clearInterval(x);
        document.getElementById("day").innerHTML = "00";
        document.getElementById("hour").innerHTML = "00";
        document.getElementById("minute").innerHTML = "00";
        document.getElementById("second").innerHTML = "00";
      }
    }, 1000);

    setInterval(function() {
      var x = document.getElementById("afterCountDown");
      var y = document.getElementById("beforeCountDown");

      var now = new Date().getTime();
      var finishDate = new Date("Mar 26, 2022 00:00:00").getTime();
      if (now < finishDate) {
        x.style.display = "none";
        y.style.display = "none";
      } else {
        clearInterval(x);
        x.style.display = "none";
        y.style.display = "none";
      }
    }, 500);
  },
  methods: {
    
getMerchantsByCategorySlug(slug, categoryId) {
  const param = slug.toLowerCase();
  
  if (param) { 
    this.showSkelton = true;
    this.showFashionDeals = true;
    this.showBanners = false;
    this.merchantsLoading = true;
    this.showMerchants = false;

    strapi.getMerchantsByCategory(param) 
      .then((res) => {
        this.merchantList = res.data;
        setTimeout(() => (this.merchantsLoading = false), 3000);
        setTimeout(() => (this.showMerchants = true), 4000);
        this.getCampaignCategoryBanners(this.merchantList);
        console.log(`${slug.toUpperCase()}_MERCHANTS__ :`, this.merchantList);
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    console.log("No category selected");
  }
  this.homePageCategoriesFilteredData.forEach(item => {
    item.selected = false;
  });

  const selectedCategory = this.homePageCategoriesFilteredData.find(item => item.id === categoryId);
  if (selectedCategory) {
    selectedCategory.selected = true;
  }
},
    getDealsPageCategories() {

      strapi
        .getDealsPageCategoriesList()
        .then((res) => {
          this.dealsPageCategories = res.data;
          
          this.dealsPageCategories.sort((a, b) => {
            return a.Category_Id - b.Category_Id;
          });

          this.homePageCategoriesFilteredData = this.dealsPageCategories;

          if (this.homePageCategoriesFilteredData.length > 0) {
            const firstCategorySlug = this.homePageCategoriesFilteredData[0].Slug;
            const firstCategoryId = this.homePageCategoriesFilteredData[0].id;
            this.getMerchantsByCategorySlug(firstCategorySlug,firstCategoryId);
      }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // Fetch Strip Banners
    getStripBanners() {
      strapi
        .getDealsStripBanners()
        .then((res) => {
          this.stripBannerList = res.data;
          console.log("STRIP_BANNERS", this.stripBannerList)
          this.stripBanner = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    
    getShopLocal() {
      window.location.href = 'https://paykoko.com/m/category?cattype=shop_local';
    },

    // getTheCampaignHeroBanners() {
    //   strapi
    //     .getCampaignPageHeroBanners()
    //     .then((res) => {
    //       this.banners = res.data;
    //       console.log("_HEROBANNERS__ :", this.banners);
    //       this.showSkelton = false;
    //       this.showBanners = true;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    getCampaignCategoryBanners(mercDetails) {
      this.banners = [];
      for (let index = 0; index < mercDetails.length; index++) {
        const item = mercDetails[index];
        if (item.merchantBanner) {
          this.banners.push(item.merchantBanner);
          console.log("_CATEGORY_HERO_BANNERS__ :", this.banners);
          this.showSkelton = false;
          this.showBanners = true;              
        }
      }
    },
    GetAllsiteSettings() {
      strapi
        .getOnsiteSettings()
        .then((res) => {
          this.onsiteSettings = res.data[0];
          this.defaultBanner = this.onsiteSettings.defaultThumbnail_deals_page.url;
          
          this.categoryFontColor = this.onsiteSettings.home_page_cat_font_color;
          this.categoryBgColor = this.onsiteSettings.home_page_cat_bg_color;

          console.log("__BANNER :", this.defaultBanner);
          console.log("colours_font",this.categoryFontColor);
          console.log("colours_bg",this.categoryBgColor);

        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 0px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;

  text-align: left;
}

.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionHead2 {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  text-align: left;
  /* line-height: 42px; */
  /* margin-top: 20px; */
  color: #393939;
}

.sectionSubs {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  /* line-height: 42px; */
  margin-top: 25px;
  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}

.header_background {
  height: 53px;
  margin-bottom: 5%;
  margin-top: 5%;
}

.text {
  color: #c9a018;
  font-size: 25px;
  font-family: "Pacifico", cursive;
  text-align: left;
  margin-top: 4%;
  margin-bottom: 4%;
}

.NoDeals {
  color: #222222;
  font-size: 25px;
  font-family: "Pacifico", cursive;
  text-align: center;
  margin-top: 50%;
  margin-bottom: 4%;
}

.hover {
  color: white;
  font-family: "Pacifico", cursive;
  text-align: center;
}

.text:hover span {
  display: none;
}

/* count down  */
.promotion_countdown_center {
  height: 4.8rem;
  /* background-color: #393939; */
  background-image: url("https://img.alicdn.com/imgextra/i3/O1CN01PmcePL1s3ggNx8mv4_!!6000000005711-0-tps-1000-200.jpg");

  background-size: cover;
  position: relative;
  border-radius: 16px;
  box-shadow: 0 10px 6px -6px #b9d8ea9e;
}
.promotion_countdown_center2 {
  height: 8.7rem;
  /* background-color: #393939; */
  background-image: url("https://img.alicdn.com/imgextra/i3/O1CN01CY2HEn1xy5WphpZkj_!!6000000006511-0-tps-1000-200.jpg");
  /* filter: grayscale(100%); */
  background-size: cover;
  position: relative;
}

.countdown {
  right: 0%;
  margin: 0%;
  display: flex;
  justify-content: center;
  align-items: left;
  /* width: 100vw;
  height: 100vh; */
  /* font-family: "Righteous", cursive; */
  position: relative;
  /* background-color: #fafafa; */
}
.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  color: #fff;
  font-size: 25px;
  border-radius: 10px;
  margin: 0 5px;
  min-width: 44px;
  min-height: 47px;
  z-index: 2;
  background-color: #bedbed;
  color: #606060;
  font-family: "Lato";
}
.countdown-item span:nth-child(1) {
  height: 33px;
}
.countdown-item span:nth-child(2) {
  font-size: 16px;
}

.card3 {
  display: grid;
  place-content: center;
  background-color: #ffffff;
  font-size: 1.5rem;
  height: 162px;
  width: 140px;
  margin-top: 20%;
  margin-bottom: 17%;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  margin-left: 10%;
}

.nav-pills .nav-link{
  color: #000000;
  background-color: rgb(217, 217, 217, 80%);
  border-radius: 30px;
  margin-right: 10px;
  padding: 10px 15px 10px 15px;
  font-size: 14px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #0217a3 ;
  border-radius: 30px;
}
.Navigation_tabs {
  margin-top: 5%;
}

/* div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu nav-item {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
} */

/* div.scrollmenu a:hover {
  background-color: #777;
} */

.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.card {
  display: inline-block;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

.circle {
  position: relative;
  width: 35%;
  height: 100%;
  margin-left: 34%;
}

.bg {
  display: inline-block;
  color: #000000;
  background: transparent;
  padding: 2px;
  border-radius: 50px;
  font-size: 9px;
  /* box-shadow: 0 3px 10px rgb(0 0 0 / 20%); */
}
.product-card {
  width: auto;
  position: relative;
  /* box-shadow: 0 3px 10px rgb(0 0 0 / 20%); */
  background: #fafafa;
  border-radius: 10px;
  margin-top: 5%;
}

.badge {
  position: absolute;
  left: 10px;
  top: 10px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 500;
  background: #ffffff;
  color: #000000;
  padding: 3px 10px;
  border-radius: 10px;
}

.badge2 {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 33px;
  font-size: 9px;
  font-weight: 500;
  background: #ffffff;
  color: #000000;
  padding: 1px 10px;
  border-radius: 10px;
}

.product-tumb {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  background: #f0f0f0;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.product-tumb img {
  max-width: 100%;
  max-height: 100%;
}

.product-details {
  padding: 5px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #ffbcd9 ;
  /* box-shadow: 0 3px 10px rgb(0 0 0 / 20%); */
}

.product-catagory {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #ccc;
  margin-bottom: 18px;
}

.product-details h4 a {
  font-weight: 500;
  display: block;
  margin-bottom: 5px;
  color: #363636;
  text-decoration: none;
  transition: 0.3s;
  font-family: Lato;
}

.product-details h4 a:hover {
  color: #fbb72c;
}

.product-details p {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 18px;
  color: #999;
}

.product-bottom-details {
  overflow: hidden;
  border-top: 1px solid #999;
}

.product-bottom-details div {
  float: left;
  width: 100%;
}

.product-price {
  font-size: 18px;
  color: #fbb72c;
  font-weight: 600;
}

.product-price small {
  font-size: 80%;
  font-weight: 400;
  text-decoration: line-through;
  display: inline-block;
  margin-right: 5px;
}

.product-links {
  text-align: right;
}

.product-links a {
  display: inline-block;
  margin-left: 5px;
  color: #e1e1e1;
  transition: 0.3s;
  font-size: 17px;
}

.product-links a:hover {
  color: #fbb72c;
}
/* customizable snowflake styling */
.snowflake {
  color: #ffffff;
  font-size: 1em;
  font-family: Arial;
  /* text-shadow: 0 0 1px #000; */
}
@-webkit-keyframes snowflakes-fall{0%{top:-10%}100%{top:100%}}
@-webkit-keyframes snowflakes-shake{0%{-webkit-transform:translateX(0px);transform:translateX(0px)}50%{-webkit-transform:translateX(80px);transform:translateX(80px)}100%{-webkit-transform:translateX(0px);transform:translateX(0px)}}
@keyframes snowflakes-fall{0%{top:-10%}100%{top:100%}}
@keyframes snowflakes-shake{0%
  {transform:translateX(0px)}50%
  {transform:translateX(80px)}100%
  {transform:translateX(0px)}}.snowflake{position:fixed;top:-10%;z-index:9999;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;-webkit-animation-name:snowflakes-fall,snowflakes-shake;-webkit-animation-duration:10s,3s;-webkit-animation-timing-function:linear,ease-in-out;-webkit-animation-iteration-count:infinite,infinite;-webkit-animation-play-state:running,running;animation-name:snowflakes-fall,snowflakes-shake;animation-duration:10s,3s;animation-timing-function:linear,ease-in-out;animation-iteration-count:infinite,infinite;animation-play-state:running,running}.snowflake:nth-of-type(0){left:1%;-webkit-animation-delay:0s,0s;animation-delay:0s,0s}.snowflake:nth-of-type(1){left:10%;-webkit-animation-delay:1s,1s;animation-delay:1s,1s}.snowflake:nth-of-type(2){left:20%;-webkit-animation-delay:6s,.5s;animation-delay:6s,.5s}.snowflake:nth-of-type(3){left:30%;-webkit-animation-delay:4s,2s;animation-delay:4s,2s}.snowflake:nth-of-type(4){left:40%;-webkit-animation-delay:2s,2s;animation-delay:2s,2s}.snowflake:nth-of-type(5){left:50%;-webkit-animation-delay:8s,3s;animation-delay:8s,3s}.snowflake:nth-of-type(6){left:60%;-webkit-animation-delay:6s,2s;animation-delay:6s,2s}.snowflake:nth-of-type(7){left:70%;-webkit-animation-delay:2.5s,1s;animation-delay:2.5s,1s}.snowflake:nth-of-type(8){left:80%;-webkit-animation-delay:1s,0s;animation-delay:1s,0s}.snowflake:nth-of-type(9){left:90%;-webkit-animation-delay:3s,1.5s;animation-delay:3s,1.5s}

.cover {
  border-radius: 8px;
  overflow: hidden;
}
.cover img {
  display: block;
  width: 100%;
  opacity: 0.95;
}
.skeleton {
  background: linear-gradient(
    90deg,
    hsl(210, 15%, 88%),
    hsl(210, 15%, 95%),
    hsl(210, 15%, 88%)
  );
  background-size: 200%;
  animation: loader 1s infinite reverse;
}
/* skeleton animation */
@keyframes loader {
  from {
    background-position: -100% 0;
  }
  to {
    background-position: 100% 0;
  }
}

/* Skelton Loader Styles */
@keyframes skeleton-animation {
  0% {
    right: 100%;
  }

  50% {
    right: -128px;
  }

  100% {
    right: 100%;
  }
}

.skeleton2 {
  overflow: hidden;
  width: 100%;
  height: 82px;
  display: grid;
  grid-template-columns: 100% 222px;
  grid-gap: 8px;
  position: relative;
  margin-bottom: 30px;
  border-radius: 15px;
}

.skeleton2:before {
  display: block;
  position: absolute;
  width: 100%;
  height: 82px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    #fff,
    rgba(255, 255, 255, 0)
  );
  content: "";
  -webkit-animation: skeleton-animation-43222382 2.25s infinite;
  animation: skeleton-animation-43222382 2.25s infinite;
}

.skeleton {
  overflow: hidden;
  margin: 10px;
  height: 170px;
  display: grid;
  grid-template-columns: 100% 222px;
  grid-gap: 8px;
  position: relative;
  border-radius: 15px;
}

.skeleton:before {
  display: block;
  position: absolute;
  width: 100%;
  height: 200px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    #fff,
    rgba(255, 255, 255, 0)
  );
  content: "";
  -webkit-animation: skeleton-animation-43222382 2.25s infinite;
  animation: skeleton-animation-43222382 2.25s infinite;
}

.skeleton .s-img {
  width: 100%;
  height: 100%;
  background: #eee;
  grid-row: 1 / 4;
}

.skeleton .s-line {
  height: 20px;
  background: #eee;
}

.skeleton .s-line.first {
  width: 100%;
}

.skeleton .s-line.second {
  width: 75%;
}

.skeleton .s-line.third {
  width: 50%;
}
.bg {
  display: inline-block;
  color: #000000;
  background: transparent;
  padding: 2px;
  border-radius: 50px;
  font-size: 9px;
  font-weight:lighter;
}

.badge3 {
  position: absolute;
  left: 10px;
  bottom: 10px;
  font-size: 9px;
  font-weight: 700;
  background: #ffffff;
  color: #000000;
  padding: 1px 5px;
  border-radius: 10px;
  margin-right: 5px
}
/* new categories */

.cat-list {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  display: inherit;
  height: 50px;
  background-color: transparent;
  border-radius: 0%;
  /* padding-top: 2%; */
  box-shadow: none;
  padding-right: 2%;
  padding-left: 2%;
  margin-bottom: 0px;
  margin-top: 5px;
}
.cat-item {
  display: inline-block;
  color: #000000;
  border-radius: 30px;
  margin-right: 10px;
  padding: 10px 15px 10px 15px;
  font-size: 14px;
}
.cat-item-text {
  text-decoration: none;
}
</style>
